import { RouteObject } from 'react-router'

import { ROUTE_CREDENTIALS } from '@/config/constants/credentials-mapping'
import { PrivateRouteUrls } from '@/config/constants/routes-urls'
import { hasRouteAccess } from '@/utils/credentials'

const pathWithoutParams = (path?: string) => (path ?? '').split('/:')?.[0]

/** Deja solo las rutas cuyas credenciales (según el mapeo) tiene la sesión; las no mapeadas pasan. */
export const getAllowedRoutes = (
  routesToValidate: RouteObject[],
  credentials: string[] = []
): RouteObject[] =>
  routesToValidate
    .filter((route) =>
      hasRouteAccess(pathWithoutParams(route.path), credentials)
    )
    .map((route) =>
      route.children
        ? ({
            ...route,
            children: getAllowedRoutes(route.children, credentials)
          } as RouteObject)
        : route
    )

/** Pantalla de inicio (dominios) si la sesión puede abrirla; si no, la primera mapeada que sí pueda. */
export const getFirstAllowedPath = (
  credentials: string[] = []
): string | undefined =>
  [PrivateRouteUrls.DOMAINS, ...Object.keys(ROUTE_CREDENTIALS)].find((path) =>
    hasRouteAccess(path, credentials)
  )
